<span [class.hide-text]="isLoading">
  <ng-content></ng-content>
</span>
<ng-container *ngIf="isLoading">
  <div class="loading-spinner-wrapper">
    <mat-spinner [diameter]="24" data-testid="spinner"></mat-spinner>
  </div>
</ng-container>
